import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ConverterService,
  OccEndpointsService,
  OccProductSearchAdapter,
  Product,
  PRODUCT_SEARCH_PAGE_NORMALIZER,
  PRODUCT_SUGGESTION_NORMALIZER,
  ProductSearchPage,
  SearchConfig,
  Suggestion,
} from '@spartacus/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { KN_BR_CUSTOMER_CURRENT } from 'src/constants/api.endpoints.constant';

const DEFAULT_SEARCH_CONFIG: SearchConfig = {
  pageSize: 18,
};

@Injectable()
export class KnBrOccProductSearchAdapter extends OccProductSearchAdapter {
  customerId: string;
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
    protected customerContextService: KnBrCustomerContextService
  ) {
    super(http, occEndpoints, converter);
    this.customerContextService.get$.subscribe((response) => {
      this.customerId = response && response.customerNumber ? response.customerNumber : null;
    });
  }

  searchByCodes(codes: string[], scope?: string): Observable<{ products: Product[]; }> {
    throw new Error('Method not implemented.');
  }

  search(query: string, searchConfig: SearchConfig = DEFAULT_SEARCH_CONFIG): Observable<ProductSearchPage> {
    const localSearchConfig = _.cloneDeep(searchConfig);
    localSearchConfig.pageSize = DEFAULT_SEARCH_CONFIG.pageSize;
    return this.http
      .get(this.getSearchEndpoint(query, localSearchConfig))
      .pipe(this.converter.pipeable(PRODUCT_SEARCH_PAGE_NORMALIZER));
  }

  loadSuggestions(term: string, pageSize: number = 3): Observable<Suggestion[]> {
    return this.http
      .get(this.getSuggestionEndpoint(term, pageSize.toString()))
      .pipe(pluck('suggestions'), this.converter.pipeableMany(PRODUCT_SUGGESTION_NORMALIZER));
  }

  protected getSearchEndpoint(query: string, searchConfig: SearchConfig): string {
    const CUSTOMER_NUMBER = this.customerId ? this.customerId : KN_BR_CUSTOMER_CURRENT;

    return this.occEndpoints.buildUrl('productSearch', {
      urlParams: { customerId: CUSTOMER_NUMBER },
      queryParams: {
        query,
        pageSize: searchConfig.pageSize,
        currentPage: searchConfig.currentPage,
        sort: searchConfig.sort,
      },
    });
  }

  protected getSuggestionEndpoint(term: string, max: string): string {
    const CUSTOMER_NUMBER = this.customerId ? this.customerId : KN_BR_CUSTOMER_CURRENT;

    return this.occEndpoints.buildUrl('productSuggestions', {
      urlParams: { customerId: CUSTOMER_NUMBER },
      queryParams: { term, max },
    });
  }
}
